import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=c43735ba"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports